import {Injectable} from '@angular/core';
import {ComponentStore} from '@ngrx/component-store';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as addonSelectors from '../../../../../add-ons/reducers';
import {ProductComponentModel, ProductType} from '../../../../../data/model';
import * as routeSelectors from '../../../../../router.selectors';

export interface TitleDisplayState {
  title: string | undefined;
  subtitle: string | undefined;
}

@Injectable()
export class PageTitleStore extends ComponentStore<TitleDisplayState> {
  readonly addon$: Observable<ProductComponentModel<ProductType> | undefined> =
    this.store.pipe(select(addonSelectors.selectAddonByCatalogId));

  readonly isShippingRoute$: Observable<boolean> = this.store.pipe(
    select(routeSelectors.selectUrl),
    map((route: string) => {
      return route?.includes('address');
    }),
  );

  readonly title$: Observable<string> = this.select(
    this.addon$,
    this.isShippingRoute$,
    (
      addon: ProductComponentModel<ProductType> | undefined,
      isShippingRoute: boolean,
    ) => {
      return isShippingRoute ? this.shippingTitle : (addon?.title ?? '');
    },
  );

  readonly subtitle$: Observable<string> = this.select(
    this.addon$,
    this.isShippingRoute$,
    (
      addon: ProductComponentModel<ProductType> | undefined,
      isShippingRoute: boolean,
    ) => {
      return isShippingRoute ? this.shippingSubtitle : addon?.subtitle || '';
    },
  );

  readonly vm$: Observable<TitleDisplayState> = this.select(
    this.title$,
    this.subtitle$,
    (title: string, subtitle: string) => {
      return {
        title,
        subtitle,
      };
    },
  );

  private readonly shippingTitle = 'Address Confirmation';
  private readonly shippingSubtitle =
    'There are items in your cart that may require us to collect sales tax.' +
    'In order for us to calculate the sales tax, we need to confirm your address.';

  constructor(private store: Store) {
    super({
      title: '',
      subtitle: '',
    });
  }
}
